//import { PdSubMenu } from './pdsubmenu.js';
import {
    Pla
} from './pla.js'; // URLパラメータでのページ内スクロール
import {
    Scr
} from './scr.js'; // スムーズスクロール
//import { ScrPos } from './scrpos.js';// スクロール連動
import {
    Modal
} from './modal.js'; // モーダル
//import { Dmenu } from './dmenu.js';
import {
    Env
} from './env.js';
import {
    Acc
} from './accordion.js';
import {
    Kubun
} from './form-kubun.js';

export class Main {
    constructor() {
        this.timerResized = false; //resize時
        this.timerScrolled = false; //scroll時
        this._click = '';
        this.env = {};

        //this.magMenu = {};

        this.smoothScroll = {};
        this.paramAncher = {};
        this.scrCheck = {};

        this.accordions = {};

        this.registerModal = {};
    }

    init() {
        //console.log('init');
        //this.scrCheck = new ScrPos();


        // DOMContentLoaded時
        // ------------------------------
        window.addEventListener('DOMContentLoaded', () => {


            // ブラウザOS環境
            this.env = new Env();
            this.env.detectEnv();

            // accordion
            this.accordions = new Acc();
            this.accordions.init();

            // スクロール時
            window.addEventListener('scroll', () => {
                clearTimeout(this.timerScrolled);
                this.timerScrolled = setTimeout(() => {
                    //this.scrCheck.checkScrPos();
                }, 200);
            });

            // ドロワーメニュー初期化
            //let drawerMenu = new Dmenu();
            //drawerMenu.init();

            // this.magMenu = new PdSubMenu();
            // this.magMenu.init();

            // ウインドウリサイズ時
            window.addEventListener('resize', () => {
                if (this.timerResized !== false) {
                    clearTimeout(this.timerResized);
                }
                this.timerResized = setTimeout(() => {
                    //envCheck.detectEnv();//thischeckDeviceType();//デバイスのtouch/clickを判定
                    //this.magMenu.updateMenu();
                    this.accordions.accResize();
                    this.registerModal.checkOverflow();
                }, 700);
            });
        });

        // load時
        // ------------------------------
        window.addEventListener("load", (event) => {
            //this.magMenu.updateMenu();
            //this.scrCheck.checkScrPos();

            // スムーズスクロール 
            // ------------------
            // 初期化
            this.smoothScroll = new Scr();
            this.smoothScroll.initSmoothScroll2();

            // スムーズスクロール URLパラメータのページアンカー指定を確認
            this.paramAncher = new Pla();
            this.paramAncher.getParam('pa', location.href);

            // スムーズスクロール URLパラメータのページアンカー指定に対応
            if (this.paramAncher.param == null) {
                //console.log(Pla.param);
            } else {
                //console.log(Pla.param);
                window.setTimeout(function () {
                    let target = document.getElementById(this.paramAncher.param);
                    this.smoothScroll.mvt.move(target);
                }, 300);
            }

            // /regist/ 希望区分 次へボタン
            // ------------------
            this.registKubun = new Kubun();
            this.registKubun.init();

            // アコーディオン
            this.accordions.accResize();

            // modal window
            // ------------------
            this.registerModal = new Modal();
            this.registerModal.init();
        });
    }
}